import { useState, useEffect } from 'react';
import { makeStyles, Tooltip, Fab } from '@material-ui/core';
import BluetoothIcon from '@material-ui/icons/Bluetooth';
// import CloseIcon from '@material-ui/icons/Close';
import { BleComponent } from './BleWidget'
import { useDispatch, useSelector } from 'react-redux';
import roles from '../../../helper/roles';
import CustomSnackBar from '../../pages/creator/experienceManager/participantsDashboard/component/CustomSnackBar';

const useStyles = makeStyles(() => ({
	bleButton: {
		position: 'absolute',
		bottom: 100,
		right: 20,
		zIndex: 2
	},
	activeButton: {
		position: 'absolute',
		bottom: "48px",
		right: '40px',
		zIndex: 2,
		display: "flex",
		width: "20px",
		backgroundColor: '#1db859',
		borderRadius: "50%"
	},
	activeText: {
		margin: "auto",
		color: 'white'
	},
	tooltip: {
		fontSize: 16,
		fontFamily: 'roboto-regular'
	},
	btn: {
		background: '#017AEF',
		color: '#FFFFFF',
		fontFamily: 'roboto-regular',
		zIndex: 3,
		height: 62,
		borderRadius: 50,
		'&:hover': {
			background: '#0f9fef'
		}
	},
}));


export default function BleWidgetComponent() {
	const classes = useStyles();
	const [isPaneOpen, setIsPaneOpen] = useState(false);
	const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || '{}') : "";
	const [webWidgetRole, setwebWidgetRole] = useState(false);
	const [compatibleBrowser, setCompatibleBrowser] = useState(false);
	const apolloClient = useSelector((state: any) => state.apolloClient);
	const [snackAlertType, handleSnackAlertType] = useState('');
	const [snackAlertMsg, handleSnackMsg] = useState('');
	const [isShownSnackAlert, setShownSnackAlert] = useState(false);
	const [activeDevice, setactiveDevice] = useState(0);
	const [ismin, setIsmin] = useState(false);

	const dispatch = useDispatch();
	useEffect(() => {
		if (loginUserData && loginUserData.role_access) {
			if (loginUserData.role_access.length) {
				const web_widget = loginUserData.role_access.find((val: any) => val.access_name === "web_widget");
				if (web_widget && web_widget.access_value) {
					setwebWidgetRole(true)
				}
			}
		}
		const userAgentString = navigator.userAgent;
		if (userAgentString) {
			if (userAgentString.indexOf("Chrome") > -1 || userAgentString.indexOf("Edge") > -1) {
				setCompatibleBrowser(true)
			}
		}
	}, [])
	function hideSnackAlert() {
		setShownSnackAlert(false);
		handleSnackAlertType('')
		handleSnackMsg('')
	}
	function togglemaxmin  ()  {
		setIsmin(false);
	}
	return (
		<div>
			{webWidgetRole && (
				<>
					{(!isPaneOpen||ismin) &&
						<>
							<div className={classes.bleButton}>
								{activeDevice != 0 ? <div className={classes.activeButton}><text className={classes.activeText} >{activeDevice}</text></div>
									: <></>}
								<Tooltip
									className={classes.tooltip}
									title={!compatibleBrowser ? "Web Bluetooth is only available for Chrome and Edge Browsers." : ""}
									placement="top"
									arrow={true}
								>
									<span>
										<Fab color="primary" onClick={() => {ismin===true? togglemaxmin() :setIsPaneOpen(!isPaneOpen)}} disabled={!compatibleBrowser ? true : false}>
												<Tooltip placement="left"
													title={"Web Connector"}
													arrow={true}>
													<BluetoothIcon />
												</Tooltip>
										</Fab>
									</span>
								</Tooltip>
							</div>
						</>
					}
					{isPaneOpen && (
						<BleComponent setIsPaneOpen={setIsPaneOpen}
							setactiveDevice={setactiveDevice}
							setIsmin={setIsmin}
							ismin={ismin}
							dispatch={dispatch}
							apolloClient={apolloClient}
							roles={roles}
							handleSnackAlertType={handleSnackAlertType}
							handleSnackMsg={handleSnackMsg}
							setShownSnackAlert={setShownSnackAlert} />
					)}
				</>
			)}
			<CustomSnackBar type={snackAlertType} message={snackAlertMsg} open={isShownSnackAlert} onClose={hideSnackAlert} />

		</div>
	)
}